import { updateProfile, withLoginUser } from 'src/api/user'
import { UserProfileForm } from './UserProfileForm'

export const UserProfileEditor = withLoginUser(({ user }) => (
  <UserProfileForm user={user} submit={updateProfile} />
))
